import { Breadcrumbs, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const BreadcrumbPurchase = ({
  productName,
  principalName,
  isConfirmCheckout,
}) => {
  const navigate = useNavigate();

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <Breadcrumbs
        sx={{ color: "#2C3E5D" }}
        aria-label="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
      >
        <Link
          underline="hover"
          color="inherit"
          href="/purchase"
          onClick={() => navigate("/purchase")}
        >
          Home
        </Link>
        {window.location.pathname.includes("/purchase/product-list/all") ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase/product-list/all"
            onClick={() => navigate("/purchase/product-list/all")}
          >
            Semua Produk
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase/product-list/special-offer"
        ) ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase/product-list/special-offer"
            onClick={() => navigate("/purchase/product-list/special-offer")}
          >
            Penawaran Special
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase/product-list/most-search"
        ) ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase/product-list/most-search"
            onClick={() => navigate("/purchase/product-list/most-search")}
          >
            Paling Banyak Dicari
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase/product-list/recent-search"
        ) ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase/product-list/recent-search"
            onClick={() => navigate("/purchase/product-list/recent-search")}
          >
            Berdasarkan Pencarianmu
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase/product-list/keyword="
        ) ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase/product-list/keyword="
            onClick={() => navigate("/purchase/product-list/keyword=")}
          >
            Pencarian
          </Link>
        ) : null}
        {window.location.pathname.includes("/principal") ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase/principal"
            onClick={() => navigate("/purchase/principal")}
          >
            Principal
          </Link>
        ) : null}
        {window.location.pathname.includes(
          "/purchase/product-list/principal/"
        ) && principalName ? (
          <Link underline="none" color="inherit">
            {principalName}
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase/detail-product/") &&
        productName ? (
          <Link underline="none" color="inherit">
            {productName}
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase/cart") ? (
          <Link
            underline="hover"
            color="inherit"
            href="/purchase/cart"
            onClick={() => navigate("/purchase/cart")}
          >
            Keranjang Belanja
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase/checkout") ? (
          <Link color="inherit" underline="none">
            {isConfirmCheckout ? "Konfirmasi Pembayaran" : "Checkout"}
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase/confirm-checkout") ? (
          <Link color="inherit" underline="none">
            Konfirmasi Pembayaran
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase/success-payment/") ? (
          <Link color="inherit" underline="none">
            Pembayaran Berhasil
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase/activate-amanah") ? (
          <Link
            color="inherit"
            href="/purchase/activate-amanah"
            onClick={() => navigate("/purchase/activate-amanah")}
            underline="none"
          >
            Aktivasi Olin Amanah
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase/confirm-amanah") ? (
          <Link
            color="inherit"
            href="/purchase/confirm-amanah"
            onClick={() => navigate("/purchase/confirm-amanah")}
            underline="none"
          >
            Aktivasi Olin Amanah
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase/list-transaction") ? (
          <Link
            color="inherit"
            href="/purchase/list-transaction"
            onClick={() => navigate("/purchase/list-transaction")}
            underline="none"
          >
            Daftar Pesanan
          </Link>
        ) : null}
        {window.location.pathname.includes("/purchase/complaint") ? (
          <Link color="inherit" underline="none">
            Ajukan Komplain
          </Link>
        ) : null}
      </Breadcrumbs>
    </div>
  );
};

export default BreadcrumbPurchase;
